import React, { useState, useEffect } from "react";
import ListingPopUp from "./ListingPopUp.js";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@chakra-ui/react";
import AppBar from "@mui/material/AppBar";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Toolbar from "@mui/material/Toolbar";
import { firestore } from "../Firebase";
import { getDocs, collectionGroup, query } from "firebase/firestore";
import { ClassNames } from "@emotion/react";
import PlaceDetails from "./PlaceDetails";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import Avatar from "@mui/material/Avatar";
import AddIcon from "@mui/icons-material/Add";
import CssBaseline from "@mui/material/CssBaseline";
import MenuIcon from "@mui/icons-material/Menu";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import IconButton from "@mui/material/IconButton";
import MoreIcon from "@mui/icons-material/MoreVert";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

const StyledFab = styled(Fab)({
  position: "absolute",
  zIndex: 1,
  top: -30,
  left: 0,
  right: 0,
  margin: "0 auto",
});

const Listings = () => {
  const styles = {
    formControl: {
      minWidth: "120",
      marginBottom: "30px",
    },
    selectEmpty: {
      marginTop: "2px",
    },
    loading: {
      height: "600px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    container: {
      padding: "25px",
      height: "100vh",
    },
    marginBottom: {
      marginBottom: "30px",
    },
    list: {
      // height: "50px",
      // overflow: "auto",

      overflowY: "scroll",
      position: "fixed",
    },
  };
  const [type, setType] = useState("all");
  const [rating, setRating] = useState("");
  const [listingArr, setArr] = useState([]);
  const places = [
    { name: "Cool Food Shelter" },
    { name: "Nice Restaurant" },
    //   { name: "Come eat here" },
  ];

  const [openDialog, setOpenDialog] = useState(false);
  const openPopUp = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    const listings = query(collectionGroup(firestore, "listings"));
    const allListings = [];
    const getList = async () => {
      const querySnapshot = await getDocs(listings);
      querySnapshot.forEach((doc) => {
        const d = doc.data();
        allListings.push({
          address: d.Address,
          desc: d.Description,
        });
      });
    };

    getList();
    setArr(allListings);
    console.log(listingArr);
    return () => {
      // this now gets called when the component unmounts
    };
  }, []);

  return (
    <div style={styles.container}>
      <Box
        // position="fixed"

        height={"100vh"}
        marginTop={-110}
        width={"100%"}
        sx={{ flexGrow: 1, marginBottom: 1 }}
        overflowY="scroll"
      >
        <AppBar style={{ background: "#D60270" }} position="static">
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              margin={0}
            >
              <FavoriteBorderIcon />
            </IconButton>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
              margin={0}
            >
              We got you!
            </Typography>
            <Search>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search..."
                inputProps={{ "aria-label": "search" }}
              />
            </Search>
          </Toolbar>
        </AppBar>

        {/* ------------------------------------------------------------------------ */}
        <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
          <InputLabel id="demo-simple-select-standard-label">
            Locations
          </InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={type}
            onChange={setType}
            label="type"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value="restaurants">Restaurants</MenuItem>
            <MenuItem value="foodshelters">Food Shelters</MenuItem>
          </Select>
        </FormControl>

        <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }}>
          <InputLabel id="demo-simple-select-standard-label">
            LGBTQ+ Friendliness
          </InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={rating}
            onChange={setRating}
            label="rating"
          >
            <MenuItem value="all">All</MenuItem>
            <MenuItem value={3}>Above 3.0</MenuItem>
            <MenuItem value={4}>Above 4.0</MenuItem>
          </Select>
        </FormControl>
        {/* ------------------------------------------------------------------- */}
        {/* <Grid container spacing={3} className={styles.list}> */}
        <div container spacing={3} className={styles.list}>
          {places?.map((place, i) => (
            <Grid item key={i} xs={12}>
              <PlaceDetails place={place} />
            </Grid>
          ))}
        </div>
        {/* </Grid> */}
        {/* --------------------------------------------------------------------- */}
        <AppBar
          position="static"
          width="30"
          flexgrow="1"
          // color="primary"
          style={{ background: "#D60270" }}
          sx={{ top: "auto", bottom: 0 }}
        >
          <Toolbar>
            <StyledFab color="secondary" aria-label="add">
              <AddIcon onClick={openPopUp} />
              <ListingPopUp open={openDialog} handleClose={handleCloseDialog} />
            </StyledFab>
            <Box sx={{ flexGrow: 1 }} />
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
};

export default Listings;
